import { getAccount, putAccount, putPassword, uploadPhotoUser } from '@/api/settings.api'
import { editAccount } from '../../../../api/settings.api'

export const FETCH_ACCOUNT = 'FETCH_ACCOUNT'
export const FETCH_ACCOUNT_LOADING = 'FETCH_ACCOUNT_LOADING'
export const FETCH_ACCOUNT_DONE = 'FETCH_ACCOUNT_DONE'
export const FETCH_ACCOUNT_ERROR = 'FETCH_ACCOUNT_ERROR'

export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT'
export const UPDATE_ACCOUNT_LOADING = 'UPDATE_ACCOUNT_LOADING'
export const UPDATE_ACCOUNT_DONE = 'UPDATE_ACCOUNT_DONE'
export const UPDATE_ACCOUNT_ERROR = 'UPDATE_ACCOUNT_ERROR'

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const CHANGE_PASSWORD_LOADING = 'CHANGE_PASSWORD_LOADING'
export const CHANGE_PASSWORD_DONE = 'CHANGE_PASSWORD_DONE'
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR'

export const UPLOAD_PHOTO = 'UPLOAD_PHOTO'
export const UPLOAD_PHOTO_LOADING = 'UPLOAD_PHOTO_LOADING'
export const UPLOAD_PHOTO_DONE = 'UPLOAD_PHOTO_DONE'
export const UPLOAD_PHOTO_ERROR = 'UPLOAD_PHOTO_ERROR'

export const EDIT_ACCOUNT = 'EDIT_ACCOUNT'
export const EDIT_ACCOUNT_LOADING = 'EDIT_ACCOUNT_LOADING'
export const EDIT_ACCOUNT_DONE = 'EDIT_ACCOUNT_DONE'
export const EDIT_ACCOUNT_ERROR = 'EDIT_ACCOUNT_ERROR'

export default {
  [FETCH_ACCOUNT] (context) {
    context.commit(FETCH_ACCOUNT_LOADING)
    return getAccount()
      .then((response) => {
        context.commit(FETCH_ACCOUNT_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_ACCOUNT_ERROR, error)
        console.error(error)
      })
  },

  [UPDATE_ACCOUNT] (context, payload) {
    context.commit(UPDATE_ACCOUNT_LOADING)
    return putAccount(payload)
      .then((response) => {
        context.commit(UPDATE_ACCOUNT_DONE, response)
      })
      .catch((error) => {
        context.commit(UPDATE_ACCOUNT_ERROR, error)
      })
  },

  [CHANGE_PASSWORD] (context, payload) {
    context.commit(CHANGE_PASSWORD_LOADING)
    return putPassword(payload)
      .then((response) => {
        context.commit(CHANGE_PASSWORD_DONE, response)
      })
      .catch((error) => {
        context.commit(CHANGE_PASSWORD_ERROR, error)
      })
  },

  [UPLOAD_PHOTO] (context, formData) {
    context.commit(UPLOAD_PHOTO_LOADING)
    return uploadPhotoUser(formData)
      .then((response) => {
        context.commit(UPLOAD_PHOTO_DONE, response)
      })
      .catch((error) => {
        context.commit(UPLOAD_PHOTO_ERROR, error)
      })
  },

  [EDIT_ACCOUNT] (context, payload) {
    context.commit(EDIT_ACCOUNT_LOADING)
    return editAccount(payload)
      .then((response) => {
        context.commit(EDIT_ACCOUNT_DONE, response)
      })
      .catch((error) => {
        context.commit(EDIT_ACCOUNT_ERROR, error)
      })
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/settings/account/actions.js